import type { MrmStateFE } from 'domain/vehicle';
import { useMemo } from 'react';

import useMRMProcess from '../mrm/hooks/useMRMProcess';

import type { MRMStateValue } from 'API';

import './styles/MRMBadge.scss';

interface Props {
    mrmState?: { value?: MRMStateValue | MrmStateFE | null; updatedAt?: unknown } | null;
}

const MRMBadge = ({ mrmState }: Props) => {
    const { isPerformingMRM, isMRC, isReleasingMRC } = useMRMProcess(mrmState?.value);

    const { label, icon } = useMemo(() => {
        const spinner = (
            <span
                data-testid='mrm-progress-icon'
                className='rioglyph rioglyph-spinner MRMBadge__icon MRMBadge__icon--rotating'
            />
        );

        const pause = <span data-testid='mrm-progress-icon' className='rioglyph rioglyph-pause MRMBadge__icon' />;

        switch (true) {
            case isMRC:
                return {
                    label: 'MRC',
                    icon: pause,
                };
            case isPerformingMRM:
                return {
                    label: 'MRM',
                    icon: spinner,
                };
            case isReleasingMRC:
                return {
                    label: 'MRC',
                    icon: pause,
                };
            default:
                return { label: null, icon: null };
        }
    }, [isMRC, isPerformingMRM, isReleasingMRC]);

    if (!label || !icon) {
        return null;
    }

    return (
        <div className='MRMBadge'>
            {icon}
            <p className='text-11'>{label}</p>
        </div>
    );
};

export default MRMBadge;
